var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, IconButton, Input, Typography, } from '@one-thd/sui-atomic-components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Close, Search } from '@one-thd/sui-icons';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useCallback, useEffect, useState } from 'react';
import { getCPSItemLevelSearch } from '../../../api/oms/order-history';
import { useCommonContext, usePurchaseHistoryContext, useExperienceContext, useSearchResultsContext, } from '../../../hooks/useContexts';
import { getDocument, getWindow } from '../../../utils/general';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { getPlaceholderValue, makeSearchRequestBody, redirectToSearchResultsPage, } from '../util/searchResultsUtils';
import { FeatureSwitches } from '../../../constants/feature-switches';
export var OrderSearch = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.searchText, searchText = _h === void 0 ? '' : _h, setSearchText = _a.setSearchText, resultsCount = _a.resultsCount;
    var thdCustomerInfo = useThdCustomer();
    var isMobile = useCommonContext().isMobile;
    var orderHistoryData = usePurchaseHistoryContext().orderHistoryData;
    var channel = useExperienceContext().channel;
    var _j = useSearchResultsContext(), setSearchItems = _j.setSearchItems, searchPageNumber = _j.searchPageNumber, setSearchPageNumber = _j.setSearchPageNumber, setLoading = _j.setLoading;
    var _k = useSearchParams(), setSearchParams = _k[1];
    var navigate = useNavigate();
    var orderHistoryInfo;
    if (((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.location.pathname) ===
        '/myaccount/purchase-history/search-results') {
        orderHistoryInfo = JSON.parse(((_c = getWindow()) === null || _c === void 0 ? void 0 : _c.sessionStorage.getItem('orderHistoryInfo')) || '{}');
    }
    else if (((_d = getWindow()) === null || _d === void 0 ? void 0 : _d.location.pathname) === '/myaccount/purchase-history') {
        (_e = getWindow()) === null || _e === void 0 ? void 0 : _e.sessionStorage.setItem('orderHistoryInfo', JSON.stringify({
            userId: orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.userId,
        }));
    }
    var pastSearches = JSON.parse((_g = (_f = getWindow()) === null || _f === void 0 ? void 0 : _f.sessionStorage.getItem('pastSearches')) !== null && _g !== void 0 ? _g : '[]');
    var _l = useState(pastSearches), searchHistory = _l[0], setSearchHistory = _l[1];
    var _m = useState({
        showSearchHistory: false,
        showInputError: false,
        showSearchButton: false,
    }), enableSearchProperties = _m[0], setEnableSearchProperties = _m[1];
    var handleRemovePastSearchItem = function (item) {
        var _a;
        var updatedSearches = searchHistory.filter(function (searchItem) { return searchItem !== item; });
        setSearchHistory(updatedSearches);
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('pastSearches', JSON.stringify(updatedSearches));
    };
    var getItemLevelSearchData = useCallback(function (searchItem) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, status_1, error_1, status_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 4]);
                    setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showInputError: false })); });
                    if (setLoading)
                        setLoading(function (prevState) { return (__assign(__assign({}, prevState), { initialResults: true })); });
                    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('pastSearches', JSON.stringify(__spreadArray([searchItem], pastSearches, true)));
                    request = makeSearchRequestBody(searchItem, thdCustomerInfo, orderHistoryData, orderHistoryInfo, searchPageNumber, []);
                    return [4 /*yield*/, getCPSItemLevelSearch(request, channel)];
                case 1:
                    response = _c.sent();
                    status_1 = response ? response.status : null;
                    if (status_1 === null) {
                        setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showInputError: true })); });
                        return [2 /*return*/];
                    }
                    if (setSearchItems) {
                        setSearchItems(response.data);
                        setSearchPageNumber(2);
                    }
                    setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showSearchHistory: false, showSearchButton: false })); });
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _c.sent();
                    if (typeof error_1 === 'object' &&
                        error_1 !== null &&
                        'response' in error_1 &&
                        typeof error_1.response ===
                            'object') {
                        status_2 = (_b = error_1.response) === null || _b === void 0 ? void 0 : _b.status;
                        if (status_2 === 500 || status_2 === 404) {
                            if (status_2)
                                setSearchText(searchItem);
                            if (setSearchItems)
                                setSearchItems({
                                    itemCount: 0,
                                    lineItems: [],
                                });
                            return [2 /*return*/];
                        }
                    }
                    setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showSearchHistory: false, showSearchButton: false })); });
                    return [3 /*break*/, 4];
                case 3:
                    if (setLoading)
                        setLoading(function (prevState) { return (__assign(__assign({}, prevState), { initialResults: false })); });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [pastSearches, setLoading, setSearchItems, setSearchText]);
    var handleOnFormSubmit = useCallback(function (searchItem) { return __awaiter(void 0, void 0, void 0, function () {
        var windowObj, searchParams;
        return __generator(this, function (_a) {
            if (searchItem === '') {
                setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showInputError: true, showSearchHistory: false, showSearchButton: false })); });
                return [2 /*return*/];
            }
            windowObj = getWindow();
            if (windowObj) {
                searchParams = new URLSearchParams({ search: searchItem });
                windowObj.history.pushState({}, '', "/myaccount/purchase-history/search-results?".concat(searchParams.toString()));
                setSearchParams({ search: searchItem });
            }
            getItemLevelSearchData(searchItem);
            return [2 /*return*/];
        });
    }); }, [getItemLevelSearchData]);
    useEffect(function () {
        var _a, _b;
        if (searchText &&
            ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) ===
                '/myaccount/purchase-history/search-results') {
            getItemLevelSearchData(searchText);
        }
    }, []);
    useEffect(function () {
        var _a;
        var handleClickOutside = function (event) {
            var _a;
            var target = event.target;
            var searchHistoryElement = (_a = getDocument()) === null || _a === void 0 ? void 0 : _a.querySelector('.sui-relative');
            if (searchHistoryElement &&
                !searchHistoryElement.contains(target) &&
                !target.closest('.sui-input') &&
                !target.closest('.sui-icon-button') &&
                !target.closest('.sui-absolute') &&
                !target.closest('.sui-overflow-hidden')) {
                setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showSearchHistory: false, showSearchButton: false })); });
            }
        };
        (_a = getDocument()) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', handleClickOutside);
        return function () {
            var _a;
            (_a = getDocument()) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-grow" },
        React.createElement("div", { className: "sui-flex sui-flex-col" },
            React.createElement("div", { className: "sui-flex sui-w-full sui-align-middle sui-relative sui-gap-[8px]" },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full sui-relative" },
                    React.createElement(Input, { autoComplete: "off", value: searchText, placeholder: getPlaceholderValue(isMobile), onChange: function (event) {
                            setSearchText(event.target.value);
                        }, inputProps: {
                            onKeyDown: function (event) {
                                var _a, _b;
                                if (event.key === 'Enter') {
                                    if (((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) ===
                                        '/myaccount/purchase-history') {
                                        redirectToSearchResultsPage(searchText, navigate);
                                        return;
                                    }
                                    handleOnFormSubmit(searchText);
                                }
                            },
                            onFocus: function () {
                                return setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showSearchHistory: true, showSearchButton: true })); });
                            },
                        }, "aria-describedby": "search-by-textfield", endAdornment: searchText.length > 0 ? (React.createElement(IconButton, { "aria-label": "clear-search", icon: Close, onClick: function () {
                                setSearchText('');
                            } })) : (React.createElement(IconButton, { disabled: true, "aria-label": "submit-search-by", icon: Search, onClick: function () {
                                var _a, _b;
                                if (((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) ===
                                    '/myaccount/purchase-history') {
                                    redirectToSearchResultsPage(searchText, navigate);
                                    return;
                                }
                                handleOnFormSubmit(searchText);
                            } })), fullWidth: true }),
                    enableSearchProperties.showSearchHistory &&
                        searchHistory.length > 0 && (React.createElement("div", { className: "sui-absolute sui-top-[45px] sui-left-0 sui-z-10 sui-w-full sui-bg-white sui-px-[12px] sui-pt-[12px]", style: {
                            border: '1px solid black',
                            backgroundColor: 'white',
                        }, role: "listbox", "aria-label": "Past searches" }, Array.from(new Set(searchHistory.filter(function (item) { return item !== ''; })))
                        .slice(0, 5)
                        .map(function (item, key) { return (React.createElement("div", { key: key, className: "sui-ml-[12px] sui-pb-[12px] sui-text-[#7a7978] sui-flex sui-justify-between sui-items-center", role: "option", "aria-selected": "false" },
                        React.createElement(Typography, { style: { cursor: 'pointer' }, color: "subtle", onClick: function () {
                                var _a, _b;
                                setEnableSearchProperties(function (prevState) { return (__assign(__assign({}, prevState), { showSearchHistory: false })); });
                                setSearchText(item);
                                if (((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) ===
                                    '/myaccount/purchase-history') {
                                    redirectToSearchResultsPage(item, navigate);
                                    return;
                                }
                                handleOnFormSubmit(item);
                            } }, item),
                        React.createElement(Close, { style: { cursor: 'pointer' }, size: "small", onClick: function () { return handleRemovePastSearchItem(item); } }))); }))),
                    FeatureSwitches.enableCPSAnnouncementBanner &&
                        resultsCount !== 0 && (React.createElement("div", { className: "sui-w-full sui-mt-1" },
                        React.createElement(Typography, { id: "search-by-textfield", variant: "body-sm", color: "subtle" }, "Search by item description, order number or PO/Job name.")))),
                React.createElement("div", { className: "sui-flex sui-justify-center sui-overflow-hidden sui-max-w-[44px] sui-max-h-[44px]" }, enableSearchProperties.showSearchButton && (React.createElement(Button, { variant: "primary", onClick: function () {
                        var _a, _b;
                        if (((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) ===
                            '/myaccount/purchase-history') {
                            redirectToSearchResultsPage(searchText, navigate);
                            return;
                        }
                        handleOnFormSubmit(searchText);
                    } }, isMobile ? React.createElement(Search, { shrink: 0 }) : React.createElement(Search, { size: "small" }))))),
            enableSearchProperties.showInputError && (React.createElement("div", { className: "sui-mt-2" },
                React.createElement(AlertBanner, { status: "error", size: "small" }, "Please enter an item description, order number or PO/Job name."))))));
};
